(function($) {
    function new_map( $el ) {
        var $markers = $el.find('.marker');
        var args = {
            zoom                    : 15,
            center                  : new google.maps.LatLng(0, 0),
            mapTypeId               : google.maps.MapTypeId.ROADMAP,
            streetViewControl       : false,
            mapTypeControl          : false,
            scaleControl            : false,
            panControl              : false,
            zoomControl             : true,
            scrollwheel             : false,
            fullscreenControl       : false,
        };
        var map = new google.maps.Map( $el[0], args);
        map.markers = [];
        $markers.each(function(){
            add_marker( $(this), map );
        });
        center_map( map );
        return map;
    }

    function add_marker( $marker, map ) {
        var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
        console.log($marker.attr('data-lat'), $marker.attr('data-lng'));
        var image = new google.maps.MarkerImage('/wp-content/themes/rdc/assets/svg/rdc-marker.svg', null, null, null, new google.maps.Size(42, 42));
        var marker = new google.maps.Marker({
            position: latlng,
            map        : map,
            icon    : image
        });
        map.markers.push( marker );
        if( $marker.html() )
        {
            var infowindow = new google.maps.InfoWindow({
                content        : $marker.html()
            });
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }
    function center_map( map ) {
        var bounds = new google.maps.LatLngBounds();
        $.each( map.markers, function( i, marker ){
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
            bounds.extend( latlng );
        });
        if( map.markers.length == 1 )
        {
            map.setCenter( bounds.getCenter() );
            map.setZoom( 14 );
        }
        else
        {
            map.fitBounds( bounds );
        }
    }
    var map = null;
    $(document).ready(function(){
        $('.map').each(function(){
            map = new_map( $(this) );
        });
    });
})(jQuery);